import React from "react";
import { Gem, MapPin, Wine } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Weddings & Italian Destination Weddings",
  description: "An exclusive experience for your most beautiful day. Timeless portraits that capture love in black and white, developed on the spot.",
  icon: Gem,
  href: "/WeddingsPage"
}, {
  title: "Street Life & Public Squares",
  description: "Bringing the art of analog photography to the people. Authentic portraits created with vintage camera carts and developed in the light of day.",
  icon: MapPin,
  href: "/ContactPage"
}, {
  title: "Party & Welcome Events",
  description: "Welcome your guests with a touch of vintage class. A tangible, elegant, and instant keepsake to celebrate every special moment together.",
  icon: Wine,
  href: "/ContactPage"
}];
export default function EssenzeDaEvento() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="essenze-da-evento" ref={ref} className={cn("dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-20 relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-serif font-medium tracking-tight text-primary">Event Essences</h2>
          <p className="text-muted-foreground font-sans max-w-2xl mx-auto text-lg">Three unique ways to experience the magic of Vintage Portraits. Partner with Italian Minuteros to choose the perfect experience for your event.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <Link key={i} to={service.href} className="block group h-full" data-index={i}>
              <Card className="h-full border-border/50 bg-card transition-all duration-500 ease-out group-hover:bg-gradient-to-br group-hover:from-neutral-800 group-hover:to-neutral-900 group-hover:-translate-y-2 group-hover:border-primary/30 overflow-hidden relative">
                <CardHeader className="pt-10 pb-4 flex flex-col items-center text-center relative z-10">
                  <div className="mb-6 p-4 rounded-full bg-background/50 border border-border/50 transition-all duration-500 group-hover:border-primary/50 group-hover:bg-background/80 group-hover:shadow-[0_0_30px_-5px_var(--color-primary)]">
                    <service.icon className="w-10 h-10 text-muted-foreground transition-all duration-500 group-hover:text-primary group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_var(--color-primary)]" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-serif text-2xl text-foreground group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center pb-10 relative z-10">
                  <CardDescription className="font-sans text-base text-muted-foreground leading-relaxed group-hover:text-foreground/80 transition-colors duration-300">
                    {service.description}
                  </CardDescription>
                </CardContent>
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}